import script from "./CountryEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CountryEditModal.vue?vue&type=script&setup=true&lang=js"

import "./CountryEditModal.vue?vue&type=style&index=0&id=6fb1b5c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb1b5c0"]])

export default __exports__